import {useAui} from '@assistant-ui/react';
import {IconButton} from '@wandb/components';
import React, {useCallback} from 'react';

import {useTrackWBAgentChats, useTrackWBAgentPanel} from './useTrackWBAgent';
import {useWBAgentContextStore} from './WBAgentContextStore';

export const WBAgentHeader = () => {
  const aui = useAui();
  const setOpen = useWBAgentContextStore(s => s.setOpen);
  const clearRuns = useWBAgentContextStore(s => s.clearRuns);
  const docked = useWBAgentContextStore(s => s.docked);
  const setDocked = useWBAgentContextStore(s => s.setDocked);
  const historySidebarOpen = useWBAgentContextStore(s => s.historySidebarOpen);
  const setHistorySidebarOpen = useWBAgentContextStore(
    s => s.setHistorySidebarOpen
  );
  const {trackDocked, trackUndocked, trackClosed} = useTrackWBAgentPanel();
  const {trackChatCreated} = useTrackWBAgentChats();

  const handleNewChat = useCallback(() => {
    aui.threads().switchToNewThread();
    clearRuns();
    trackChatCreated();
  }, [aui, clearRuns, trackChatCreated]);

  const handleToggleDocked = useCallback(() => {
    const next = !docked;
    setDocked(next);
    if (next) {
      trackDocked();
    } else {
      trackUndocked();
    }
  }, [docked, setDocked, trackDocked, trackUndocked]);

  const handleClose = useCallback(() => {
    setOpen(false);
    trackClosed();
  }, [setOpen, trackClosed]);

  return (
    <div className="flex items-center justify-between border-b border-solid border-moon-250 px-16 py-12">
      <div className="flex items-center gap-8">
        <IconButton
          variant="ghost"
          icon="menu"
          aria-label="history"
          isActive={historySidebarOpen}
          onClick={() => {
            setHistorySidebarOpen(!historySidebarOpen);
          }}
          tooltip={{children: 'Chat history'}}
        />
        <h2 className="text-xl font-semibold">W&B Agent</h2>
      </div>
      <div>
        <IconButton
          variant="ghost"
          icon="compose"
          aria-label="new-chat"
          onClick={handleNewChat}
          tooltip={{
            children: 'Start new chat (clears current)',
          }}
        />
        <IconButton
          variant="ghost"
          icon={docked ? 'undock' : 'dock-arrow'} // To do: switch to dock-arrow and undock when core-ux PR is approved
          aria-label={docked ? 'undock chat' : 'dock chat'}
          onClick={handleToggleDocked}
          tooltip={{
            children: docked ? 'Undock chat' : 'Dock chat',
          }}
        />
        <IconButton
          variant="ghost"
          icon="close"
          aria-label="close"
          onClick={handleClose}
          tooltip={{
            children: 'Minimize',
          }}
        />
      </div>
    </div>
  );
};
